import { 
  Heart, 
  PartyPopper, 
  Building2, 
  Briefcase, 
  Calendar, 
  Smartphone,
  Camera,
  Baby,
  Sparkles,
  Clock,
  Sunset,
  Plane,
  LucideIcon
} from "lucide-react";

export interface ServiceData {
  icon: LucideIcon;
  title: string;
  slug: string;
  description: string;
  shortDescription: string;
  features: string[];
  image: string;
  category: "personal" | "business" | "celebrations";
  href: string;
}

export const SERVICES_DATA: ServiceData[] = [
  {
    icon: Heart,
    title: "Weddings",
    slug: "weddings",
    description: "Cinematic wedding films that capture every emotion, every glance, and every tear of joy from your special day.",
    shortDescription: "Cinematic wedding films that capture every emotion and moment of your special day.",
    features: ["Full-day coverage", "Highlight film", "Documentary edit", "Raw footage available"],
    image: "/__l5e/assets-v1/8668c854-c2d1-4c7d-842b-eb5651ed39ee/weddings.jpg",
    category: "personal",
    href: "/services/weddings",
  },
  {
    icon: Heart,
    title: "Engagement",
    slug: "engagement",
    description: "Celebrate your commitment with a cinematic film capturing the excitement, love, and joy of your engagement.",
    shortDescription: "Celebrate your commitment with a cinematic film capturing the excitement.",
    features: ["Proposal capture", "Ring reveal", "Couple moments", "Celebration coverage"],
    image: "/__l5e/assets-v1/95816f2b-baa9-47b8-a2d9-ed438b727a54/engagement.jpg",
    category: "personal",
    href: "/services/engagement",
  },
  {
    icon: Sunset,
    title: "Love Shoot",
    slug: "love-shoot",
    description: "An intimate cinematic experience capturing the magic between you two in stunning locations.",
    shortDescription: "Intimate cinematic experience capturing the magic between you two.",
    features: ["Golden hour shots", "Location of choice", "Romantic storytelling", "Social clips"],
    image: "/__l5e/assets-v1/cf7d4a4d-0988-41aa-99f9-fa969b5ad0df/love-shoot.jpg",
    category: "personal",
    href: "/services/love-shoot",
  },
  {
    icon: Clock,
    title: "Anniversary",
    slug: "anniversary",
    description: "Honor your journey together with a cinematic film that captures the depth of your love story.",
    shortDescription: "Honor your journey together with a cinematic love story film.",
    features: ["Couple portraits", "Location shoots", "Interview segments", "Photo montage"],
    image: "/__l5e/assets-v1/1ad3cf49-0a13-4b2d-b154-b1936092e86f/anniversary.jpg",
    category: "personal",
    href: "/services/anniversary",
  },
  {
    icon: Baby,
    title: "Baby Shower",
    slug: "baby-shower",
    description: "Celebrate the joy of expecting with a cinematic film that captures every smile, surprise, and tender moment.",
    shortDescription: "Celebrate expecting with a film capturing every tender moment.",
    features: ["Gift reveals", "Guest reactions", "Decorative details", "Highlight reel"],
    image: "/__l5e/assets-v1/4c8d9c48-21fa-40cb-8fa2-3075cb70b6c1/baby-shower.jpg",
    category: "celebrations",
    href: "/services/baby-shower",
  },
  {
    icon: Sparkles,
    title: "Bridal Shower",
    slug: "bridal-shower",
    description: "An elegant film capturing the joy, laughter, and love shared with the bride before her big day.",
    shortDescription: "Elegant films capturing the joy shared with the bride-to-be.",
    features: ["Party vibes", "Guest messages", "Fun moments", "Stylish coverage"],
    image: "/__l5e/assets-v1/d25da42c-c133-4056-9a49-0ef68b07adda/bridal-shower.jpg",
    category: "celebrations",
    href: "/services/bridal-shower",
  },
  {
    icon: PartyPopper,
    title: "Festivals",
    slug: "festivals",
    description: "Dynamic festival coverage capturing the energy, performances, and unforgettable moments of your event.",
    shortDescription: "Dynamic festival coverage capturing the energy and performances.",
    features: ["Artist performances", "Crowd atmosphere", "Behind-the-scenes", "Highlight reels"],
    image: "/__l5e/assets-v1/9bc47ff3-28e4-440f-8d29-a09502c4c4d2/festivals.jpg",
    category: "business",
    href: "/services/festivals",
  },
  {
    icon: Building2,
    title: "Property",
    slug: "property",
    description: "Stunning property videos that showcase spaces in their best light, helping you sell faster and for more.",
    shortDescription: "Stunning property videos that showcase spaces in their best light.",
    features: ["Cinematic walkthroughs", "Aerial footage", "Agent branding", "Virtual tours"],
    image: "/__l5e/assets-v1/bf3d7749-6a1f-4fb2-8509-0c6008640d60/property.jpg",
    category: "business",
    href: "/services/property",
  },
  {
    icon: Briefcase,
    title: "Brands & Business",
    slug: "brands",
    description: "Professional brand films that tell your story, connect with audiences, and elevate your business presence.",
    shortDescription: "Professional brand films that tell your story and connect with audiences.",
    features: ["Brand stories", "Product videos", "Corporate films", "Team profiles"],
    image: "/__l5e/assets-v1/9e48a012-294d-498f-a422-9a1a9001bfcf/brands.jpg",
    category: "business",
    href: "/services/brands",
  },
  {
    icon: Calendar,
    title: "Events",
    slug: "events",
    description: "Comprehensive event coverage from corporate functions to private celebrations, capturing every key moment.",
    shortDescription: "Comprehensive event coverage from corporate functions to private celebrations.",
    features: ["Conference coverage", "Gala events", "Award ceremonies", "Private parties"],
    image: "/__l5e/assets-v1/103ed05a-a136-49f5-8437-60714a1c414c/events.jpg",
    category: "celebrations",
    href: "/services/events",
  },
  {
    icon: Smartphone,
    title: "Social Media Content",
    slug: "social-media",
    description: "Scroll-stopping content optimized for every platform, designed to engage and grow your audience.",
    shortDescription: "Scroll-stopping content optimized for every platform.",
    features: ["Reels & TikToks", "YouTube content", "Stories & shorts", "Content packages"],
    image: "/__l5e/assets-v1/f9c6e3db-7eca-48e2-87ab-eb8260c7b19a/social-media.jpg",
    category: "business",
    href: "/services/social-media",
  },
  {
    icon: Camera,
    title: "Modelling",
    slug: "modelling",
    description: "Portfolio reels and fashion videography that showcase talent and make a lasting impression on agencies.",
    shortDescription: "Portfolio reels and fashion videography that make an impact.",
    features: ["Portfolio reels", "Fashion campaigns", "Lookbook videos", "Behind-the-scenes"],
    image: "/__l5e/assets-v1/b5aa8a29-df02-4c27-8812-6e3b1c455d62/modelling.jpg",
    category: "personal",
    href: "/services/modelling",
  },
  {
    icon: Calendar,
    title: "Live Stream",
    slug: "live-stream",
    description: "Professional multi-camera live streaming for events, conferences, and special occasions broadcast worldwide.",
    shortDescription: "Professional live streaming broadcast worldwide.",
    features: ["Multi-camera setup", "Real-time graphics", "Platform streaming", "Recording included"],
    image: "/__l5e/assets-v1/f4e93a0b-b36a-4fc7-83bd-8b7a7b9872ac/live-stream.jpg",
    category: "business",
    href: "/services/live-stream",
  },
  {
    icon: Plane,
    title: "Drone",
    slug: "drone",
    description: "Breathtaking aerial cinematography capturing stunning perspectives of your property, event, or brand from above.",
    shortDescription: "Stunning aerial cinematography capturing unique perspectives.",
    features: ["4K aerial footage", "Licensed pilots", "Cinematic shots", "Property flyovers"],
    image: "/__l5e/assets-v1/90554c6c-e937-4f87-9870-74e5c9bc692f/drone.jpg",
    category: "business",
    href: "/services/drone",
  },
];

// Derive service types from the services data
export const SERVICE_TYPES = [
  ...SERVICES_DATA.map(s => s.title),
  "Other",
] as const;

export type ServiceType = typeof SERVICE_TYPES[number];

// Service categories for filtering
export const SERVICE_CATEGORIES = [
  { id: "all", label: "All Services" },
  { id: "personal", label: "Personal" },
  { id: "business", label: "Business" },
  { id: "celebrations", label: "Celebrations" },
] as const;

// Helper function to get service by slug
export const getServiceBySlug = (slug: string): ServiceData | undefined => {
  return SERVICES_DATA.find(s => s.slug === slug);
};

// Helper function to get service by title
export const getServiceByTitle = (title: string): ServiceData | undefined => {
  return SERVICES_DATA.find(s => s.title === title);
};
